// test1227
(1227 && 0);
